var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportrecht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158.13 164.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.45,137.09c.99,2.05,1.76,4.31,2.02,6.59,2.04,18.35-21.76,28.45-33.58,13.88-9.12-11.24-2.96-27.66,10.91-30.61-1.79-2.07-3.38-4.3-4.69-6.7L29.13,27.67l-19.62,9.75C4.84,34.21,1.25,31.62.18,29.83c-.28-.48-.24-1.08.13-1.49,1.08-1.21,3.56-2.29,4.01-2.5,3.51-1.63,17.55-8.39,25.93-12.88,4.58-2.75,5.58-1.75,7.44,2.77l41.18,97.67c3.77,8.48,12.92,13.03,22.01,10.77,16.85-6.72,56.44-24.69,56.95-23.97.78,1.12,0,13-1.95,13.93-14.48,6.29-28.84,12.87-43.36,19.07-3.24,1.38-6.3,2.82-9.81,3.48-3.05.58-6.17.66-9.26.41ZM75.87,139.26c-8.53.85-6.8,14.26,2.05,12.49,7.52-1.5,6.14-13.3-2.05-12.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.55,51.08c3.29-.42,5.53,1.25,6.9,4.08,4.53,9.39,7.93,19.7,12.36,29.17.64,1.82.41,3.73-.49,5.3-.7,1.23-1.86,2.13-3.16,2.68l-46.52,19.83c-3.74,1.29-6.71-.26-8.36-3.69-4.5-9.34-7.89-19.58-12.29-29.01-1.2-3.36.19-6.56,3.33-8.12l46.25-19.62c.61-.23,1.34-.55,1.98-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.96.05c3.23-.37,5.42,1.18,6.77,3.96,4.55,9.36,7.94,19.71,12.36,29.18,1.26,3.02-.28,6.71-3.24,8.03l-46.25,19.62c-2.83,1.34-6.03.74-8.01-1.72-4.83-10.18-8.91-20.75-13.4-31.1-1.02-3.19.67-6.65,3.77-7.85,15.36-6.05,30.26-13.44,45.66-19.38.76-.29,1.52-.65,2.34-.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportrecht);
export default __webpack_public_path__ + "static/media/Transportrecht.92778f8570b66fdfd7a79362b3fe67e5.svg";
export { ForwardRef as ReactComponent };